<script setup>
import { ref } from 'vue';
const props = defineProps(['teamId', 'alterText']);
var team = ref();
var isFilteredTeam = ref();
var filterConditionTeamId = ref();

const getTeamName = (team_id) => {
    team = JSON.parse(localStorage.getItem("teams"))[props.teamId]

    isFilteredTeam = false;
    filterConditionTeamId = JSON.parse(localStorage.getItem("filterConditionTeam"))
    if (filterConditionTeamId == props.teamId) {
        isFilteredTeam = true;
    }
    if (team) {
        //return team.name.substring(0, 4)
        return team.short_name
    } else {
        return ''
    }
};
</script>

<template>
    <template v-if="getTeamName() != ''">
        <span class="selected-team" v-if="isFilteredTeam">{{ getTeamName() }}</span>
        <span class="team-badge" v-else>{{ getTeamName() }}</span>
    </template>
    <template v-else>
        <span v-if="props.alterText" style="color:#d3d3d3">{{  props.alterText }}</span>
    </template>
</template>

<style scoped>
.team-badge {
  display: inline-block;
  font-size: 0.75em;
  padding: 0.1em;
  text-decoration: none;
  background: #fff;
  color: #dc143c;
  width: 53px;
  margin: 1px;
  text-align: center;
  white-space: nowrap;
  border: solid 1px #dc143c;
  vertical-align: baseline;
}

.selected-team {
  display: inline-block;
  font-size: 0.75em;
  padding: 0.1em;
  text-decoration: none;
  background: #e9967a;
  color: #fff;
  width: 53px;
  margin: 1px;
  text-align: center;
  white-space: nowrap;
  border: solid 1px #dc143c;
  vertical-align: baseline;  
}

.team-badge-empty {
  display: inline-block;
  font-size: 0.75em;
  padding: 0.1em;
  text-decoration: none;
  background: #fff;
  color: #d3d3d3;
  width: 45px;
  margin: 1px;
  text-align: center;
  white-space: nowrap;
  border: solid 1px #d3d3d3;
  vertical-align: baseline;
}
</style>